import * as React from 'react';
import { useAction, useGlobalState } from 'piral-core';
import { useTranslate } from 'piral-translate';
import { SnowLevels } from '../../types';
import { useKeycloak } from '../../../keycloak-api';

import './snowfall-button.css';

export function isChristmasTime(): boolean {
  const today = new Date();
  // von Nikolaus (06.12.)
  const inDecember = today.getTime() > new Date(today.getFullYear(), 11, 6).getTime();
  // bis inkl. Hl. 3 König (06.01.)
  const inJanuary = today.getTime() < new Date(today.getFullYear(), 0, 7).getTime();
  return inDecember || inJanuary;
}

export const SnowfallButton: React.FC = () => {
  const { keycloak } = useKeycloak();

  const setSnowLevel = useAction('setSnowLevel');
  const setSnowPileEnabled = useAction('setSnowPileEnabled');
  const snowPileEnabled = useGlobalState((state: any) => state.snowPileEnabled);
  const translate = useTranslate();
  const [levels, setLevels] = React.useState<SnowLevels[]>(['0', '1', '2', '3', '4', '5']);

  React.useEffect(() => {
    if (!keycloak) return;
    const email = keycloak.idTokenParsed?.['email'];
    const targetUsers = [
      'delstner@sip.de',
      'sinderst@sip.de',
      'rpfahler@sip.de',
      'jblengl@sip.de',
      'mnerlinger@sip.de',
      'drueck@sip.de',
      'fstocker@sip.de',
      'ksabanovic@sip.de',
      'oroell@sip.de',
    ];
    const isTargetUser = targetUsers.includes(email);
    if (!isTargetUser) return;

    setLevels(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
  }, [keycloak]);

  if (!isChristmasTime()) {
    return null;
  }

  return (
    <div className="neo-dropdown-menu neo-snowfall-menu">
      <button type="button">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" style={{ pointerEvents: 'none' }}>
          <path d="M460-293.69 323.15-158.85q-5.61 5.62-13.65 5.62t-13.65-6.62q-6.62-5.61-6.62-13.65t6.62-14.65L460-352.31V-460H352.31L187.15-294.85q-5.61 5.62-13.65 5.62t-14.65-6.62q-5.62-5.61-5.62-13.65t5.62-13.65L293.69-460H119q-7.77 0-13.38-5.73Q100-471.46 100-480q0-7.77 5.73-13.88Q111.46-500 120-500h173.69L158.85-635.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t14.65 5.62L352.31-500H460v-107.69L294.85-771.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t13.65 5.62L460-666.31V-840q0-7.77 5.73-13.88Q471.46-860 480-860q7.77 0 13.88 6.12Q500-847.77 500-840v173.69l135.85-133.84q5.61-5.62 13.65-5.62t14.65 5.62q5.62 6.61 5.62 14.65t-5.62 13.65L500-607.69V-500h107.69l164.16-164.15q5.61-5.62 13.65-5.62t14.65 6.62q5.62 5.61 5.62 13.65t-5.62 13.65L666.31-500H840q7.77 0 13.88 6.12Q860-487.77 860-480q0 8.54-6.12 14.27Q847.77-460 840-460H666.31l133.84 136.85q5.62 5.61 5.62 13.65t-5.62 13.65q-6.61 6.62-14.65 6.62t-13.65-6.62L607.69-460H500v107.69l164.15 165.16q5.62 5.61 5.62 13.65t-6.62 14.65q-5.61 5.62-13.65 5.62t-13.65-5.62L500-293.69V-119q0 7.77-6.12 13.38Q487.77-100 480-100q-8.54 0-14.27-5.73T460-120v-173.69Z" />
        </svg>
      </button>
      <div>
        <button type="button" className="neo-snowfall-toggle" onClick={() => setSnowPileEnabled(!snowPileEnabled)}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" style={{ pointerEvents: 'none' }}>
            <path d="M120-200v-80l280-360 160 160 280-280v560H120Zm80-80h560v-288L552-360 392-520 200-280v80Zm0 0h560-560Z" />
          </svg>
          {translate('schnee')}
          <span className="neo-snowfall-toggle-state" style={{ marginLeft: 'auto' }}>
            {snowPileEnabled ? 'An' : 'Aus'}
          </span>
        </button>
        {levels.map(level => (
          <button key={level} type="button" onClick={() => setSnowLevel(level)}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor" style={{ pointerEvents: 'none' }}>
              <path d="M460-293.69 323.15-158.85q-5.61 5.62-13.65 5.62t-13.65-6.62q-6.62-5.61-6.62-13.65t6.62-14.65L460-352.31V-460H352.31L187.15-294.85q-5.61 5.62-13.65 5.62t-14.65-6.62q-5.62-5.61-5.62-13.65t5.62-13.65L293.69-460H119q-7.77 0-13.38-5.73Q100-471.46 100-480q0-7.77 5.73-13.88Q111.46-500 120-500h173.69L158.85-635.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t14.65 5.62L352.31-500H460v-107.69L294.85-771.85q-5.62-5.61-5.62-13.65t6.62-14.65q5.61-5.62 13.65-5.62t13.65 5.62L460-666.31V-840q0-7.77 5.73-13.88Q471.46-860 480-860q7.77 0 13.88 6.12Q500-847.77 500-840v173.69l135.85-133.84q5.61-5.62 13.65-5.62t14.65 5.62q5.62 6.61 5.62 14.65t-5.62 13.65L500-607.69V-500h107.69l164.16-164.15q5.61-5.62 13.65-5.62t14.65 6.62q5.62 5.61 5.62 13.65t-5.62 13.65L666.31-500H840q7.77 0 13.88 6.12Q860-487.77 860-480q0 8.54-6.12 14.27Q847.77-460 840-460H666.31l133.84 136.85q5.62 5.61 5.62 13.65t-5.62 13.65q-6.61 6.62-14.65 6.62t-13.65-6.62L607.69-460H500v107.69l164.15 165.16q5.62 5.61 5.62 13.65t-6.62 14.65q-5.61 5.62-13.65 5.62t-13.65-5.62L500-293.69V-119q0 7.77-6.12 13.38Q487.77-100 480-100q-8.54 0-14.27-5.73T460-120v-173.69Z" />
            </svg>
            {translate('stufe') + ` ${level}`}
          </button>
        ))}
      </div>
    </div>
  );
};
